import rules from '@anchor/vue-assets/src/plugins/form-rules';

export default {
  role: [
    rules.required,
  ],
};
